<label class="label">Music On Hold</label>
<ng-select
  [items]="musicOnHolds"
  [nbSpinner]="loadingMOH"
  nbSpinnerSize="medium"
  nbSpinnerStatus="info"
  bindLabel="displayName"
  bindValue="id"
  fullWidth
  size="small"
  [(ngModel)]="selectedMohId"
  placeholder="Select Music On Hold"
  style="z-index: 10"
  (change)="handleMusicSelection($event)"
  [clearable]="true"
  (clear)="handleClear()"
>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
  >
    <div *ngIf="item.id == 0" class="add-music">
      <nb-icon icon="plus-circle-outline"></nb-icon>
      <span>MUSIC ON HOLD</span>
    </div>
    <div *ngIf="item.id != 0" class="music-item">
      <div>
        <nb-icon
          [icon]="(isPlaying && currentMusic === item.path) ? 'pause-circle' : 'play-circle'"
          class="icon-music"
          [ngClass]="{
            'icon-music-selected': selectedMohId == item.id
          }"
          (click)="playMusic(item.path, $event)"
        ></nb-icon>
        <span>{{ item.displayName }}</span>
      </div>
      <div>
        <nb-icon
          icon="edit-2-outline"
          style="font-size: 15px"
          (click)="updateMusicOnHold($event, item)"
        ></nb-icon>
        <nb-icon
          *ngIf="selectedMohId !== item.id"
          icon="trash-2-outline"
          style="margin-left: 5px; font-size: 15px"
          (click)="deleteMusic($event, item)"
        ></nb-icon>
      </div>
    </div>
  </ng-template>
</ng-select>
<audio #audioPlayer (ended)="isPlaying = false"></audio>
